import { render } from "./Mention.vue?vue&type=template&id=73c46d6d&scoped=true&ts=true"
import script from "./Mention.vue?vue&type=script&lang=ts"
export * from "./Mention.vue?vue&type=script&lang=ts"

import "./Mention.vue?vue&type=style&index=0&id=73c46d6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c46d6d"]])

export default __exports__